
const namespaced = true;

const state = {
  searchString: ``,
  isKeepingPreviousState: false,
};

const mutations = {
  SET_SEARCH_STRING(state, searchString) {
    state.searchString = searchString || ``;
  },
  SET_KEEPING_PREVIOUS_STATE(state, isKeepingPreviousState) {
    state.isKeepingPreviousState = isKeepingPreviousState;
  },
};

const actions = {};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
